import { useEffect, useState } from "react";
import { INITIAL_ERRORS, INITIAL_FORM } from "../constants";
import { requestGetAcadReinforcePeriod } from "services/acadReinforce/relatedToAcadReinforce";
import { errorFree } from "utils/validations";

const useMassiveLoadingForm = () => {
    //#region States
    const [currentStep, setCurrentStep] = useState(1);
    const [period, setPeriod] = useState("-");
    const [form, setForm] = useState(INITIAL_FORM);
    const [errors, setErrors] = useState(INITIAL_ERRORS);
    const [errorStack, setErrorStack] = useState({
        stack: [],
        rowCountFile: 0
    });
    //#endregion
    //#region Effects
    useEffect(() => {
        fillPeriod();
    }, []);
    //#endregion
    //#region Functions
    const fillPeriod = async () => {
        const fetchPeriod = await requestGetAcadReinforcePeriod();
        setPeriod(fetchPeriod);
    }
    const changeForm = (field, value, errorValue) => {
        setForm({
            ...form,
            [field]: value
        });
        setErrors({
            ...errors,
            [field]: errorValue
        });
    }
    const reset = () => {
        setErrors({
            ...INITIAL_ERRORS
        });
        setForm({
            ...INITIAL_FORM
        });
    }
    const changeErrors = value => {
        setErrors(value);
    }
    const isValidForm = () => {
        const { fileData } = form;
        const newErrors = {
            fileData: !fileData.base64,
        };
        const isValid = errorFree(newErrors);
        return {
            isValid, newErrors
        };
    }
    const toStep = step => {
        setCurrentStep(step);
    }
    //#endregion
    return {
        currentStep, toStep, period,
        form: {
            isValid: isValidForm,
            value: form,
            change: changeForm,
            reset
        },  errors: {
            value: errors,
            change: changeErrors
        }, errorStack: {
            value: errorStack,
            set: setErrorStack
        }
    };
}	
    
export default useMassiveLoadingForm;